import { Component, OnInit } from '@angular/core';
import { CustomerProfileSetupService } from 'src/app/services/customer-profile-setup.service';

@Component({
  selector: 'app-customer-profile-setup',
  templateUrl: './customer-profile-setup.component.html',
  styleUrls: ['./customer-profile-setup.component.css']
})
export class CustomerProfileSetupComponent implements OnInit {

  public cities = [
    { code: 1, name: "Hyderabad" },
    { code: 2, name: "Machilipatnam" },
    { code: 3, name: "Bengaluru" }
  ];
  public states = [
    { code: 1, name: "Telangana" },
    { code: 2, name: "Andhrapradesh" },
    { code: 3, name: "Karnataka" }
  ];
  constructor(public customerProfileSetup: CustomerProfileSetupService) { }

  ngOnInit(): void {
  }

  onSubmit(){
    
  }

  // onClear() {
  //   this.customerProfileSetup.customerProfileSetupForm.reset();
  //   this.customerProfileSetup.initializeGroup();
  // }

}
